import React from 'react';
import * as Sentry from '@sentry/browser';
import Button from 'components/button';
import If from 'components/if-statement';
import { onError } from 'services/apollo-client/links/error-link';
import { isAuthError } from 'services/apollo-client';

interface State {
  hasError: boolean;
  message: string;
  sentryEventId: string;
}

class ErrorBoundary extends React.Component {
  state: State = { hasError: false, message: '', sentryEventId: '' };

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidMount(): void {
    onError('errorBoundary', ({ graphQLErrors = [] }) => {
      const [error] = graphQLErrors;

      if (isAuthError(error) === false) {
        //this.setError(error);
      }
    });
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    if (process.env.NODE_ENV === 'production') {
      Sentry.withScope((scope) => {
        scope.setExtras(errorInfo);
        const sentryEventId = Sentry.captureException(error);
        this.setState({ sentryEventId });
      });
    } else {
      this.setError(error);
    }
  }

  setError(error) {
    this.setState({
      hasError: true,
      message: error?.message,
      code: error?.extensions?.code ?? error?.code,
    });
  }

  showSentryErrorDetails = () =>
    Sentry.showReportDialog({ eventId: this.state.sentryEventId });

  render() {
    if (this.state.hasError) {
      return (
        <>
          <h1>Something went wrong.</h1>
          <p>{this.state.message}</p>
          <If condition={process.env.NODE_ENV !== 'production'}>
            <Button onClick={this.showSentryErrorDetails}>
              Show error details
            </Button>
          </If>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
